import { useQuery } from '@tanstack/react-query';
import { useAuthStoreV1 } from '@/stores/authStore_v1';
import { skillsAxios, skillsAuthHeaders } from '@/services/skills';
import { RUNS_ENDPOINT, normalizeRunListResponse } from '@/services/reports';
import type { RunListResponse } from '@/services/reports';

export function useRuns(opts: { limit?: number } = {}) {
  const orgId = useAuthStoreV1((s) => s.selectedOrg?.id ?? null);
  const limit = opts.limit ?? 60;

  return useQuery<RunListResponse>({
    queryKey: ['runs', orgId, limit],
    queryFn: async () => {
      const { data } = await skillsAxios.get(RUNS_ENDPOINT, {
        params: { limit },
        headers: skillsAuthHeaders(),
      });
      return normalizeRunListResponse(data);
    },
    enabled: !!orgId,
    staleTime: 30_000,
    retry: false,
    // Keep the current runs visible while a larger "Load more" window refetches
    // (the limit is in the queryKey, so growing it is a new query) — no skeleton flash.
    placeholderData: (prev) => prev,
  });
}
